// src/api/publishApi.js
export const publishSchedule = async (payload, token) => {
  const res = await fetch(`${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/schedules/publish`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.text();
    throw new Error(err || "Failed to publish schedule");
  }
  return res.json();
};

export const fetchPublishedSchedules = async (filters, token) => {
  const query = new URLSearchParams(filters).toString();
  const res = await fetch(
    `${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/schedules/published/week?${query}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    const err = await res.text();
    throw new Error(err || "Failed to load published schedules");
  }

  return res.json();
};
